import { ReactNode } from 'react';

/** Opacity for annotations placed on a slice other than the one shown. */
export const OFF_PLANE_OPACITY = 0.4;

/**
 * The full-viewport SVG layer the annotation overlays draw into. Click-through
 * by design: only the elements that opt back in (edit handles, hover bands)
 * intercept the engine tool's mouse events.
 */
export default function AnnotationOverlaySvg({
    children,
}: {
    children: ReactNode;
}) {
    return (
        <svg
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: 6,
            }}
        >
            {children}
        </svg>
    );
}
